import React from 'react'
import ReactDOM from 'react-dom/client'
import '@shopify/polaris/build/esm/styles.css'
import './styles/app.css' // Global app styles
import './i18n' // Initialize i18n
import App from './App'
import { ShopifyAppProvider } from './components/ShopifyAppProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ShopifyAppProvider>
      <App />
    </ShopifyAppProvider>
  </React.StrictMode>,
)
